/**
 * Route for `campaign-browser-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignBrowserTargetingPage } from "../features/campaign-browser-targeting/CampaignBrowserTargetingPage";

export const campaignBrowserTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-browser-targeting",
	component: CampaignBrowserTargetingPage,
});

export default campaignBrowserTargetingRoute;
